import { path as d3Path } from 'd3-path';
import React, { useMemo } from 'react';

import { DEPTH_CHART_CLIP_AREA_ID } from './chartConfig';
import { ChartPoint } from './types';

function BidsAsks({
  points,
  xScale,
  yScale,
  yMin,
  fill,
  stroke,
}: {
  points: ChartPoint[];
  yMin: number;
  xScale: (num: number) => number;
  yScale: (num: number) => number;
  fill: string;
  stroke: string;
}) {
  const { area, path } = useMemo(() => {
    const area = d3Path();
    const path = d3Path();

    const [first] = points;

    const [firstX, firstY] = [
      Math.round(xScale(first.x || 0)),
      Math.round(yScale(first.y || 0)),
    ];

    path.moveTo(firstX, yScale(yMin));
    area.moveTo(firstX, yScale(yMin));

    path.lineTo(firstX, firstY);
    area.lineTo(firstX, firstY);

    let prev = { x: firstX, y: firstY };

    points.forEach(point => {
      const x = Math.round(xScale(point.x)) || 0;
      const y = Math.round(yScale(point.y)) || 0;

      area.lineTo(x, prev.y);
      area.lineTo(x, y);

      path.lineTo(x, prev.y);
      path.lineTo(x, y);

      prev = { x, y };
    });

    area.lineTo(prev.x, yScale(yMin));
    area.closePath();

    return { area, path };
  }, [points, xScale, yMin, yScale]);

  return (
    <g style={{ clipPath: `url(#${DEPTH_CHART_CLIP_AREA_ID})` }}>
      <path d={area.toString()} fill={fill} fillOpacity={0.3} />
      <path d={path.toString()} stroke={stroke} fill="none" strokeWidth={1} />
    </g>
  );
}

const MemoizedBidsAsks = React.memo(BidsAsks);

export default MemoizedBidsAsks;
